import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { getStandardHeaders } from '../util/StandardRequestHeaders';
import { ConcedeDisputeMutationVariables, MutationStatusCode } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_CONCEDE_DISPUTE = gql`
  mutation concedeDispute($input: ConcedeDisputeInput!) {
    concedeDispute(input: $input)
  }
`;

export const mutationConcedeDispute = async (
  client: ApolloClient<NormalizedCacheObject>,
  id: string,
  explanation: string,
): Promise<MutationStatusCode | undefined> => {
  const headers = await getStandardHeaders();
  const { data, errors } = await client.mutate<{ concedeDispute: MutationStatusCode }, ConcedeDisputeMutationVariables>({
    variables: { input: { id, explanation } },
    mutation: MUTATION_CONCEDE_DISPUTE,
    context: {
      headers,
    },
  });
  if (errors && errors.length > 0) {
    errors.forEach(error => {
      // Log error details in the console.
      console.error(error);
    });
    // Friendly error to the user.
    throw new Error('An error has occurred during the concede dispute mutation');
  }
  if (data && data.concedeDispute) {
    return data.concedeDispute;
  }

  return undefined;
};
